<div>
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <img src={{iconPath}} class="imgClass">
  </button>
  <mat-menu #menu="matMenu" class="menuClass">
    <mat-card class="card-notification">
      <div>
        <p class="pClassDoubt">Dúvidas?</p>
        <p class="pClassEmail">Envie um e-mail para:</p>
        <div class="divEmail">
          <a class="aClassDoubtEmail" href="mailto:hub@daycovalseguros.com.br">{{email}}</a>
        </div>
      </div>
    </mat-card>
  </mat-menu>
</div>
